


import Dashboard from "./Pages/Dashboard";
import LinkedInManagement from "./Pages/LinkedInManagement";
import CookieManagement from "./Pages/CookieManagement";
import Login from "./Components/login/Login";
import DirectLogin from "./Components/login/DirectLogin";
import LandingPage from "./Pages/landing_page";
import { PrivateRoute, AdminRoute } from "./Components/login/ProtectedRoute";
import ManageUsers from "./Pages/ManageUsers";
import PostHistoryPage from "./Pages/PostHistoryPage";
import PPT from "./Pages/PPT";
import AuthSuccess from "./Components/login/AuthSuccess";
import AccessDenied from "./Components/login/AccessDenied";
import SocialMediaSettings from "./Pages/SocialMediaSettings";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import React, { useEffect, useState } from "react";
 
// ⏰ Import auth helpers
import { startTokenTimer, getToken, logout } from "./services/authService";
import { jwtDecode } from "jwt-decode";
 
// ⏰ Session Expired Dialog
import SessionExpiredDialog from "./Components/SessionExpiredDialog";
 
function App() {
  const [sessionExpiredOpen, setSessionExpiredOpen] = useState(false);
 
  // Token check (jitna bacha hai utna timer)
  useEffect(() => {
    const token = getToken();
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const exp = decoded.exp * 1000; // expiry in ms
        const now = Date.now();
        const remaining = exp - now;
 
        if (remaining > 0) {
          console.log("⏰ Session valid for (ms):", remaining);
          startTokenTimer(token);
        } else {
          console.log("❌ Token already expired");
          logout();
        }
      } catch (err) {
        console.error("❌ Invalid token:", err);
        logout();
      }
    }
  }, []);
 
  // Listen for sessionExpired event
useEffect(() => {
  const handler = () => {
    console.log("📢 token-expired event received in App.js"); // ✅ debug
    setSessionExpiredOpen(true);
  };
  window.addEventListener("token-expired", handler);
  return () => window.removeEventListener("token-expired", handler);
}, []);


 
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/direct-login" element={<DirectLogin />} />
        <Route path="/auth-success" element={<AuthSuccess />} />
        <Route path="/access-denied" element={<AccessDenied />} />
 
        {/* Private Routes */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
 <Route
          path="/cookie-management"
          element={
            <PrivateRoute>
              <CookieManagement/>
            </PrivateRoute>
          }
        />
        <Route
          path="/ppt"
          element={
            <PrivateRoute>
              <PPT />
            </PrivateRoute>
          }
        />
 
        <Route
          path="/linkedin-management"
          element={
            <PrivateRoute>
              <LinkedInManagement />
            </PrivateRoute>
          }
        />
 
        <Route
          path="/social-media-settings"
          element={
            <PrivateRoute>
              <SocialMediaSettings />
            </PrivateRoute>
          }
        />
 
        <Route
          path="/post-history"
          element={
            <PrivateRoute>
              <PostHistoryPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/manage-users"
          element={
            <AdminRoute>
              <ManageUsers />
            </AdminRoute>
          }
        />
      </Routes>
 
      {/* Toasts */}
      <ToastContainer position="top-right" autoClose={4000} newestOnTop />
 
      {/* Session Expired Modal */}
      <SessionExpiredDialog
        open={sessionExpiredOpen}
        onClose={() => setSessionExpiredOpen(false)}
      />
    </BrowserRouter>
  );
}
 
export default App;
 
 